import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Card, CardContent } from '../components/ui/Card';
export function ViewCourse() {
  const navigate = useNavigate();
  return <div className="space-y-4" data-id="element-2476" data-mp="3fvhmb17nn4nn">
      <div className="flex items-center justify-between" data-id="element-2477" data-mp="3fuged5lxqya5">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-2478" data-mp="3bwinzzgfi656">Course</h1>
        <Button variant="secondary" size="sm" className="border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" onClick={() => navigate('/courses')} data-id="element-2479" data-mp="2o53ftq1z0um0">
          ← Back to Courses
        </Button>
      </div>

      <Card data-id="element-2480" data-mp="2s7gl6dct2qi9">
        <CardContent className="pt-6" data-id="element-2481" data-mp="2s6ygcsc2v3yq">
          <table className="text-sm w-full" data-id="element-2482" data-mp="2s5x44kjbsbff">
            <tbody data-id="element-2483" data-mp="24hdtvzgptokp">
              <tr className="border-b border-slate-100" data-id="element-2484" data-mp="24gklku23yr0g">
                <td className="py-2 pr-6 font-medium text-slate-700 w-36 align-top" data-id="element-2485" data-mp="20g0pltt9ttfw">
                  Name
                </td>
                <td className="py-2 text-slate-900" data-id="element-2486" data-mp="1m6ul7cwvqndj">
                  Ethics &amp; The Rules (with NAR Code of Ethics)
                </td>
              </tr>
              <tr className="border-b border-slate-100" data-id="element-2487" data-mp="1r2t3cirm795i">
                <td className="py-2 pr-6 font-medium text-slate-700 align-top" data-id="element-2488" data-mp="1vwxezfbts5cx">
                  Course Category
                </td>
                <td className="py-2 text-slate-900" data-id="element-2489" data-mp="20x1ryvdiyhye">Single class</td>
              </tr>
              <tr className="border-b border-slate-100" data-id="element-2490" data-mp="1391hw9icgbfm">
                <td className="py-2 pr-6 font-medium text-slate-700 align-top" data-id="element-2491" data-mp="185i5n2lmsns6">
                  Small Description
                </td>
                <td className="py-4 text-slate-800 leading-relaxed max-w-2xl" data-id="element-2492" data-mp="1d436934sp9h5">
                  <div className="space-y-3" data-id="element-2493" data-mp="1i590x6i0n6tb">
                    <p className="font-bold text-blue-700" data-id="element-2494" data-mp="1i24s1vtlvmwb">
                      CS CE credit + Complies with current NAR cycle January
                      2025-December 2027
                    </p>
                    <p data-id="element-2495" data-mp="theoe9fjs3g5">
                      The Commissioner's Rule R4-28-1101 will be the primary
                      focus of the class as it compares to the NAR Code Of
                      Ethics for REALTORS®. There will be a review of the
                      process of enforcement of both the Rules and Code of
                      Ethics. Recent changes will be addressed as well as those
                      that are often overlooked.
                    </p>
                    <p className="bg-yellow-200 font-bold px-1" data-id="element-2496" data-mp="aosvnxzxsszs">
                      REMEMBER:SEND A COPY OF YOUR CERTIFICATE TO YOUR LOCAL
                      ASSOCIATION.
                    </p>
                    <p className="bg-yellow-200 font-bold px-1" data-id="element-2497" data-mp="jlblv2gsa2so">
                      Find Email Address:{' '}
                      <a href="#" className="text-blue-600 underline" data-id="element-2498" data-mp="eqnumvueauae">
                        https://www.DesertSageSeminars.com/Arizona_Local_Associations
                      </a>
                    </p>
                  </div>
                </td>
              </tr>
              <tr className="border-b border-slate-100" data-id="element-2499" data-mp="3917c218r1y13">
                <td className="py-2 pr-6 font-medium text-slate-700 align-top" data-id="element-2500" data-mp="3du0geo0b34cn">
                  Full Description
                </td>
                <td className="py-4 text-slate-800 leading-relaxed max-w-2xl" data-id="element-2501" data-mp="2z65lr22qmpwx">
                  <div className="space-y-3" data-id="element-2502" data-mp="344qnj5xn1hnh">
                    <p className="font-bold text-blue-700" data-id="element-2503" data-mp="341cj7s5eyyde">
                      CS CE credit + Complies with current NAR cycle January
                      2025-December 2027
                    </p>
                    <p data-id="element-2504" data-mp="kma34ejc57h">
                      The Commissioner's Rule R4-28-1101 will be the primary
                      focus of the class as it compares to the NAR Code Of
                      Ethics for REALTORS®. There will be a review of the
                      process of enforcement of both the Rules and Code of
                      Ethics. Recent changes will be addressed as well as those
                      that are often overlooked.
                    </p>
                    <p className="bg-yellow-200 font-bold px-1" data-id="element-2505" data-mp="2rnh4zmi1pljk">
                      REMEMBER:SEND A COPY OF YOUR CERTIFICATE TO YOUR LOCAL
                      ASSOCIATION.
                    </p>
                    <p className="bg-yellow-200 font-bold px-1" data-id="element-2506" data-mp="2hwmh6dp5idw0">
                      Find Email Address:{' '}
                      <a href="#" className="text-blue-600 underline" data-id="element-2507" data-mp="2cv5m4ytcllnc">
                        https://www.DesertSageSeminars.com/Arizona_Local_Associations
                      </a>
                    </p>
                    <p data-id="element-2508" data-mp="35k32gwe018dg">
                      ****This Class Will Comply With NAR Code of Ethics
                      requirement PLUS 3 CE hrs. for Commissioner's Standards***
                    </p>
                    <p data-id="element-2509" data-mp="2vq45ebss8esd">
                      <em data-id="element-2510" data-mp="1p87785kvmlrj">
                        Jon Kichen, the owner of Desert SageSeminars and
                        instructor of this course, is approved by the Arizona
                        Association of Realtors as a Certified Ethics
                        Instructor.
                      </em>
                    </p>
                    <p data-id="element-2511" data-mp="4qeprp4tc255">
                      *When completed, be sure to send a copy this certificate
                      to your local Association to show you have complied with
                      NAR's Code of Ethics requirement. Go to{' '}
                      <a href="#" className="text-blue-600 underline" data-id="element-2512" data-mp="jet52zjf1j2l">
                        LINKS/RESOURCES
                      </a>{' '}
                      for email address of your local Association.
                    </p>
                    <p data-id="element-2513" data-mp="sg93sa0vbwqz">
                      When you click to print your certificate, the system will
                      download a PDF (of your certificate). You can save it and
                      then attach it to an email to your Association.
                    </p>
                    <div className="pl-4 space-y-1" data-id="element-2514" data-mp="2z55jtq48m1ar">
                      <p data-id="element-2515" data-mp="2z5xgz5dhg735">
                        *Per ADRE rules, you may NOT complete more than 3
                        classes (9 hrs.) in a calendar day
                      </p>
                    </div>
                    <p className="text-blue-700 font-medium" data-id="element-2516" data-mp="2n5gxg3pknqr4">
                      The Arizona Department of Real Estate requires that we
                      confirm your identity and that you are the person taking
                      the classes. Impersonating a real estate licensee is a
                      felony in the State of Arizona and will be subject to a
                      real estate forfeiture for either or both parties. If you
                      are NOT the person named in the registration, we strongly
                      recommend that you log out and not continue. We reserve
                      the right to use reasonable means to verify your identity.
                    </p>
                    <p data-id="element-2517" data-mp="3osq7wdaastef">There are 5 sections to this course</p>
                    <p data-id="element-2518" data-mp="3ouaxrplo3o5y">
                      Take NOTES: You can print pages or copy &amp; paste for
                      your notes
                    </p>
                    <p data-id="element-2519" data-mp="gb8x99ylsocf">
                      You can review the material at any time throughout the
                      course
                    </p>
                    <p data-id="element-2520" data-mp="2d2b2r30ocsl">You need 100% to pass each quiz in order to proceed</p>
                    <p data-id="element-2521" data-mp="78hkn6tzrmj7">
                      You need 80% to pass the final. The final is a compilation
                      of the quiz questions you already answered
                    </p>
                    <p data-id="element-2522" data-mp="3ti2d10pj0tz5">
                      Your certificate will be date stamped upon completion of
                      your final.
                    </p>
                    <p data-id="element-2523" data-mp="3kop9l4tu69yt">
                      If you would like to remain paperless, when you click
                      "Print Certificate", a PDF will also be downloaded on your
                      computer. Save in a folder for <strong data-id="element-2524" data-mp="3ar13xjuozi1v">5</strong> years
                      (per ADRE rules)
                    </p>
                  </div>
                </td>
              </tr>
              <tr className="border-b border-slate-100" data-id="element-2525" data-mp="3m77gcia7ngo7">
                <td className="py-2 pr-6 font-medium text-slate-700" data-id="element-2526" data-mp="3m7pa989ehisy">
                  Passing Score
                </td>
                <td className="py-2 text-slate-900" data-id="element-2527" data-mp="3ha79i55je9w1">80</td>
              </tr>
              <tr className="border-b border-slate-100" data-id="element-2528" data-mp="3c8hvcgn0pg3q">
                <td className="py-2 pr-6 font-medium text-slate-700" data-id="element-2529" data-mp="37agf03gz7uvy">
                  Credit Type
                </td>
                <td className="py-2" data-id="element-2530" data-mp="32i5dwxai231t">
                  <a href="#" className="text-blue-600 hover:underline" data-id="element-2531" data-mp="32h3spzzrs06d">
                    3 hrs. Comm. Standards
                  </a>
                </td>
              </tr>
              <tr className="border-b border-slate-100" data-id="element-2532" data-mp="2tk369yw9gc5k">
                <td className="py-2 pr-6 font-medium text-slate-700" data-id="element-2533" data-mp="2ojyo84fpf9d8">
                  Course No
                </td>
                <td className="py-2 text-slate-900" data-id="element-2534" data-mp="2jldnm3wjino9">CD17355</td>
              </tr>
              <tr className="border-b border-slate-100" data-id="element-2535" data-mp="29gxa3h6j9inm">
                <td className="py-2 pr-6 font-medium text-slate-700" data-id="element-2536" data-mp="29ii4n6sul1lh">
                  Publish
                </td>
                <td className="py-2 text-slate-900" data-id="element-2537" data-mp="2jelgx5heygm5">yes</td>
              </tr>
              <tr data-id="element-2538" data-mp="2jcigdrimx536">
                <td className="py-2 pr-6 font-medium text-slate-700" data-id="element-2539" data-mp="2odoa9so16yea">Price</td>
                <td className="py-2 text-slate-900" data-id="element-2540" data-mp="2oblmlfacphcq">$19.95</td>
              </tr>
            </tbody>
          </table>
        </CardContent>
      </Card>
    </div>;
}